import request from '../helpers'

const state = {
  loading: false,
  currentIndex: -1,
  items: []
}

const mutations = {
  CHANGE_LOADING_STATE(state, loading) {
    state.loading = loading
  },
  LOAD_ITEMS(state, items) {
    state.items = items
  },
  UPDATE_CAUSE(state, data) {
    state.currentIndex = state.items.findIndex(c => c.id == data.id)
    if (state.currentIndex == -1) {
      state.items.push({ id: data.id })
      state.currentIndex = 0;
    }

    if (Boolean(data.name))
      state.items[state.currentIndex].name = data.name
    if (Boolean(data.howToVotePageId))
      state.items[state.currentIndex].howToVotePageId = data.howToVotePageId
    if (Boolean(data.votes))
      state.items[state.currentIndex].votes = data.votes
    if (Boolean(data.localizations))
      state.items[state.currentIndex].localizations = data.localizations
    if (Boolean(data.pages))
      state.items[state.currentIndex].pages = data.pages
  },
  UPDATE_VOTE(state, data) {
    state.currentIndex = state.items.findIndex(c => c.id == data.causeId)
    var voteIndex = state.items[state.currentIndex].votes.findIndex(v => v.id == data.id)
    state.items[state.currentIndex].votes.splice(voteIndex, 1, data)
  },
  DELETE_VOTE(state, data) {
    state.currentIndex = state.items.findIndex(c => c.id == data.causeId)
    var voteIndex = state.items[state.currentIndex].votes.findIndex(v => v.id == data.id)
    state.items[state.currentIndex].votes.splice(voteIndex, 1)
  },
  UPDATE_PAGE(state, data) {
    state.currentIndex = state.items.findIndex(c => c.id == data.causeId)
    var pageIndex = state.items[state.currentIndex].pages.findIndex(v => v.id == data.id)
    if (pageIndex == -1)
      state.items[state.currentIndex].pages.push(data)
    else
      state.items[state.currentIndex].pages.splice(pageIndex, 1, data)
  },
  UPDATE_PAGES(state, data) {
    state.items[state.currentIndex].pages = data
  }
}

const actions = {
  getCauses({ commit }) {
    return request({ commit: commit, method: 'get', url: 'causes', successCallback: causes => {
      commit('LOAD_ITEMS', causes);
    }});
  },
  getCause({ commit, dispatch }, id) {
    return request({ commit: commit, method: 'get', url: `causes/${id}`, successCallback: cause => {
      commit('UPDATE_CAUSE', cause);
      dispatch('settings/updateActiveCause', cause, { root: true });
    }});
  },
  saveCause({ commit, dispatch }, data) {
    var promises = [];
    data.localizations.forEach(loc => {
      if (loc.logoUrl.indexOf('blob') == 0) {
        // There is a file to upload
        let formData = new FormData();
        formData.append('file', loc.file);
        promises.push(request({ commit: commit, method: 'post', url: `causes/${data.id}/image`, data: formData, multipart: true, successCallback: url => {
          loc.logoUrl = url
        }}))
      }
    });
    var response = {};
    Promise.all(promises).then(_ => {
      response = request({ commit: commit, method: 'post', url: 'causes', data: data, successCallback: cause => {
        commit('UPDATE_CAUSE', cause);
        dispatch('settings/updateActiveCause', cause, { root: true });
      }});
    })
    return response;
  },
  updateCause({ commit, dispatch, state }, data) {
    // In case the causes were not loaded, load them before updating the cause
    // This case happens when the details URL is accessed directly
    if (state.items.length == 0) {
      dispatch('getData').then(_ => {
        commit('UPDATE_CAUSE', data)
      })
    } else {
      commit('UPDATE_CAUSE', data)
    }
  }
}

const getters = {
  currentCause: state => {
    if (state.items[state.currentIndex] == undefined)
      return { name: 'Napco Truck Tracking', localizations: [] }
    return state.items[state.currentIndex]
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}